var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import Masonry from 'react-masonry-css';
import Teaser from "./components/Teaser";
import Filters from './components/Filters';
import axios from "axios";
import './../scss/app.scss';
var App = function (props) {
    var _a = useState([]), stories = _a[0], setStories = _a[1];
    var _b = useState([]), categories = _b[0], setCategories = _b[1];
    //const [tags, setTags] = useState<Tag[]>([] as Tag[])
    var _c = useState([]), teasers = _c[0], setTeasers = _c[1];
    var _d = useState(true), isLoading = _d[0], setIsLoading = _d[1];
    var currentLang = window.CURRENT_LANG ? window.CURRENT_LANG : 'de';
    var storiesBaseUrl = process.env.API_SERVER_BASE + "stories?lang=" + currentLang;
    var categoriesBaseUrl = process.env.API_SERVER_BASE + "category?lang=" + currentLang;
    var breakpointColumnsObj = {
        default: 4,
        1200: 2,
        720: 1,
    };
    var isUpdatingClass = !isLoading ? ' is-loading' : '';
    function fetchData() {
        return __awaiter(this, void 0, void 0, function () {
            var storiesUrl, categoriesUrl, response, categoriesResponse, data, categories;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        storiesUrl = new URL(storiesBaseUrl);
                        categoriesUrl = new URL(categoriesBaseUrl);
                        return [4 /*yield*/, axios.get(storiesUrl.toString())];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, axios.get(categoriesUrl.toString())];
                    case 2:
                        categoriesResponse = _a.sent();
                        return [4 /*yield*/, response.data];
                    case 3:
                        data = _a.sent();
                        return [4 /*yield*/, categoriesResponse.data];
                    case 4:
                        categories = _a.sent();
                        setStories(data);
                        categories.map(function (cat) {
                            cat.selected = false;
                        });
                        setCategories(categories);
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    var updateStories = function (e, index) {
        var copy = __spreadArray([], categories, true);
        copy[index].selected = !copy[index].selected;
        setCategories(copy);
        var catParams = [];
        var urlParams = '';
        categories.map(function (cat) {
            if (cat.selected) {
                catParams.push(cat.categoryId);
            }
        });
        if (catParams.length) {
            urlParams = "&cats=" + catParams.join(',');
        }
        var url = new URL(storiesBaseUrl + urlParams);
        setIsLoading(true);
        fetchByCats(url);
    };
    function fetchByCats(url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, appContainer, offset, bodyRect, elementRect, elementPosition, offsetPosition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get(url.toString())];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.data];
                    case 2:
                        data = _a.sent();
                        setStories(data);
                        setIsLoading(false);
                        appContainer = document.getElementById('memory-mappings-app');
                        if (appContainer) {
                            offset = 100;
                            bodyRect = document.body.getBoundingClientRect().top;
                            elementRect = appContainer.getBoundingClientRect().top;
                            elementPosition = elementRect - bodyRect;
                            offsetPosition = elementPosition - offset;
                            window.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        fetchData();
    }, []);
    useEffect(function () {
        if (stories) {
            var teasers_1 = stories.map(function (story, i) {
                return (_jsx("div", __assign({ className: 'stories-grid__item' }, { children: _jsx(Teaser, { teaser: story }, void 0) }), i));
            });
            setTeasers(teasers_1);
        }
    }, [stories]);
    return _jsx(_Fragment, { children: stories ? _jsxs("div", __assign({ className: "container" + isUpdatingClass + " m-auto" }, { children: [_jsx(Filters, { tags: [], filterCallback: updateStories, disable: isLoading, categories: categories }, void 0), _jsx(Masonry, __assign({ breakpointCols: breakpointColumnsObj, className: "stories-grid px-3 md:px-0 xl:px-0", columnClassName: "stories-grid__column" }, { children: teasers }), void 0)] }), void 0) : 'is-loading' }, void 0);
};
export default App;
